import React, { useState } from 'react';
import ProgressSteps from '../components/ToolBox/ProgressSteps';
import { Step1_Input, Step2_Review, Step3_Complete } from '../components/ToolBox/WatiContactSegmentSync';

const WatiContactSegmentSync = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [clid, setClid] = useState('');
  const [phones, setPhones] = useState([]);
  const [segmentName, setSegmentName] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleStep1Next = ({ clid: nextClid, phones: nextPhones, segmentName: nextSegmentName }) => {
    setClid(nextClid);
    setPhones(nextPhones);
    setSegmentName(nextSegmentName);
    setCurrentStep(1);
  };

  const handleComplete = (syncResult) => {
    setResult(syncResult);
    setCurrentStep(2);
  };

  const handleRestart = () => {
    setCurrentStep(0);
    setPhones([]);
    setResult(null);
    setError('');
  };

  return (
    <div className="max-w-5xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">WATI Contact Segment Sync</h1>
          <p className="text-gray-600">
            Paste phone numbers, ensure they exist as WATI contacts, and build a segment from them.
          </p>
        </div>

        <ProgressSteps currentStep={currentStep} totalSteps={3} />

        {currentStep === 0 && (
          <Step1_Input onNext={handleStep1Next} loading={false} error={error} setError={setError} />
        )}

        {currentStep === 1 && (
          <Step2_Review
            clid={clid}
            phones={phones}
            segmentName={segmentName}
            onBack={() => setCurrentStep(0)}
            onComplete={handleComplete}
          />
        )}

        {currentStep === 2 && <Step3_Complete result={result} onRestart={handleRestart} />}
      </div>
    </div>
  );
};

export default WatiContactSegmentSync;
